/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////
/**
 * The fleet's typography contract, repointed at the Alif & Lakshita faces.
 *
 * The faces and their `--font-*` variables are declared in
 * `src/assets/fonts/fonts.css`; the roles are named in `./design-tokens`.
 * The inherited sections all read `FONT_FAMILY` and `TEXT_PROPS`, so
 * repointing them here moves every one of them onto the new typography at
 * once, and the existing names keep working.
 *
 * @important colours here stay as THEME TOKEN NAMES (`mainColorText`), not
 * literal values. `./colors` imports from this file, so importing colour
 * values back from `./colors` would form a cycle and leave TEXT_PROPS
 * undefined at module-eval time. The token names resolve through the Chakra
 * theme, which reads `./colors` — one direction only.
 *
 * The `var(--fontItalic-*)` styles are the hook the live-simulation drawer
 * (`@invitato/imagination-room`) uses to toggle italics at runtime. They are
 * kept because ENABLE_LIVE_SIMULATION is on for this template.
 */
import { FONTS } from './design-tokens';

export const FONT_FAMILY = {
  /** all-caps titles, roman names, countdown figures */
  heading: FONTS.display,
  /** the script face — swash capitals and ghost text */
  subHeading: FONTS.script,
  /** running copy */
  body: FONTS.body,
  /** the serif-italic voice: small labels, paragraphs, pill text, addresses */
  accent: FONTS.accent,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    lineHeight: 1.15,
    textAlign: 'center',
    color: 'mainColorText',
    // the design sets every title in CAPS, so the baseline's lowercase
    // transform is deliberately not carried over
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    textAlign: 'center',
    color: 'mainColorText',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    color: 'mainColorText',
  },
  /** the italic serif carrying every small label and paragraph in the design */
  accent: {
    fontFamily: 'accent',
    fontSize: 'body',
    fontStyle: 'italic',
    fontWeight: 'body',
    color: 'mainColorText',
    lineHeight: 1.5,
  },
};
